import { Component, OnDestroy, OnInit } from "@angular/core";
import { MedicalOrderScann } from "src/app/model/medical-order-scann";
import { BudgetWizardService } from "../services/budget.wizard.service";
import { Budget } from "src/app/model/budget/budget";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/services/auth.service";
import { MedicalOrderProcedureExtractionComponent } from "../../dialogs/medical-order-procedure-extraction/medical-order-procedure-extraction.component";
import { MatDialog } from "@angular/material";
import { NotificationToastService } from "src/app/services/notification-toast.service";

@Component({
  selector: "app-budget-scann",
  templateUrl: "./budget-scann.component.html",
  styleUrls: ["./budget-scann.component.css"],
})
export class BudgetScannComponent implements OnInit, OnDestroy {
  budget: Budget;
  scanns: MedicalOrderScann[] = [];
  private currentBudgetSuscripcion: Subscription;

  constructor(
    private service: BudgetWizardService,
    private notificationToastService: NotificationToastService,
    private authService: AuthService,
    public dialog: MatDialog
  ) {}

  get canExtractProcedures(): boolean {
    if (
      this.authService.enabledIA() &&
      this.service.currentBudget &&
      this.service.currentBudget.Plan
    ) {
      return true;
    } else {
      return false;
    }
  }

  ngOnInit() {
    this.currentBudgetSuscripcion = this.service.currentBudget$.subscribe(
      (budget) => {
        if (budget) {
          this.budget = null;
          console.log(budget.Name);
          setTimeout(() => {
            this.budget = budget;
            this.scanns = [...budget.Scanns];
          }, 500);
        }
      },
    );
  }

    async onMecicalOrderSelected(base64: string) {
      if (!this.service.currentBudget.Plan.Plan) {
        this.notificationToastService.error(
          "Debe seleccionar un plan para el procedimiento",
          "Admisión"
        );
        return;
      }

      if (!this.service.currentBudget.Plan.AliquotTax) {
        this.notificationToastService.error(
          "Debe seleccionar una alícuota",
          "Admisión"
        );
        return false;
      }

      const dialogRef = this.dialog.open(
        MedicalOrderProcedureExtractionComponent,
        {
          width: "90vw",
          height: "90vh",
           panelClass: 'full-dialog',
          data: {
            service: this.service,
            fileBase64: base64,
            planId: this.service.currentBudget.Plan.Plan.Id,
            physicianId: this.service.currentBudget.PhysicianId,
            centerId: this.service.currentBudget.CenterId,
            equipmentId: this.service.currentBudget.EquipmentId
          },
        }
      );
      dialogRef.afterClosed().subscribe(async (result) => {
        if (result && result.length > 0) {
           await this.service.loadProcedures(this.service.currentBudget.Plan);
          for (const procedure of result) {
            await this.service.setProcedureIdSelected(
              procedure.PracticeRegion.Id
            );
          }
        }
      });
    }

  onMecicalOrderScannChange(scanns: MedicalOrderScann[]) {
    this.service.setScanns(scanns);
  }

  ngOnDestroy(): void {
    if (this.currentBudgetSuscripcion) {
      this.currentBudgetSuscripcion.unsubscribe();
    }
  }
}
